import { useContext } from "react";
import { Redirect, Route } from "react-router-dom";

import { ROUTES } from "src/config/constants";
import { AuthContext } from "src/contexts/AuthContext";

const AuthenticatedRoute = ({ component: Component, roles, ...rest }: { [x: string]: any; component: any; roles: any }) => {
  const value = useContext(AuthContext);
  const auth = value?.auth;

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!auth || (roles && roles.indexOf(auth.role) === -1)) {
          return <Redirect to={ROUTES.home} />;
        }
        return <Component {...props} />;
      }}
    />
  );
};

export default AuthenticatedRoute;
